export default {
    getShouldBeStartDate(period){
        let value = new Date()
        value.setHours(value.getHours() - period+1)
        value.setMinutes(0, 0, 0);
        return value
    },
    getShouldBeEndDate(){
        let value = new Date()
        //value.setHours(value.getHours() - period+1)
        value.setMinutes(0, 0, 0);
        return value
    }
}